import { render } from "./quick_view_settings.vue?vue&type=template&id=4b9187b6"
import script from "./quick_view_settings.js?vue&type=script&lang=js"
export * from "./quick_view_settings.js?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__